import {
  CashDownIcon,
  Certificate01Icon,
  DownPaymentGiftLetterIcon,
  FillableVOEIcon,
  InsuranceRequestFormIcon,
  LandlordPrivatePropertyWaiverIcon,
  LeaseAgreementForManufacturedHomeIcon,
  LeasedCommunityCertificationIcon,
  PrimaryResidenceStatementIcon,
  ContractRequestFormIcon,
  RetailerDisclosureCertIcon,
  FloorPlanPayoffFormIcon,
  SiteImprovementAllowancesIcon,
} from "src/assets/icons";

export const customerConditionsData = [
  {
    title: "Cash Down Payment Letter",
    icon: CashDownIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/cash-down-payment-letter.pdf",
  },
  {
    title: "Delivery Certification Form",
    icon: Certificate01Icon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/delivery-certification-form.pdf",
  },
  {
    title: "Down Payment Gift Letter",
    icon: DownPaymentGiftLetterIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/down-payment-gift-letter.pdf",
  },
  {
    title: "Fillable VOE",
    icon: FillableVOEIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/fillable-voe.pdf",
  },
  {
    title: "Insurance Request Form",
    icon: InsuranceRequestFormIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/insurance-request-form.pdf",
  },
  {
    title: "Property Owner / Landlord Waiver",
    icon: LandlordPrivatePropertyWaiverIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/property-owner-landlord-waiver.pdf",
  },
  {
    title: "Lease Agreement for Manufactured Home",
    icon: LeaseAgreementForManufacturedHomeIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/lease-agreement-for-manufactured-home.pdf",
  },
  {
    title: "Leased Community Certification",
    icon: LeasedCommunityCertificationIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/leased-community-certification.pdf",
  },
  {
    title: "Primary Residence Statement",
    icon: PrimaryResidenceStatementIcon,
    link: "https://docs.porchpass.com/branded/porchpass/customer-conditions/primary-residence-statement.pdf",
  },
];

export const fundingConditionsData = [
  {
    title: "Floor Plan Payoff Form",
    icon: FloorPlanPayoffFormIcon,
    link: "https://docs.porchpass.com/branded/porchpass/funding-conditions/floor-plan-payoff-form.pdf",
  },
];

export const mspAllowanceData = [
  {
    title: "Site Improvement Allowances Single Wide",
    icon: SiteImprovementAllowancesIcon,
    link: "https://docs.porchpass.com/branded/porchpass/msp-allowance-chart/site-improvement-allowances-single-wide.pdf",
  },
  {
    title: "Site Improvement Allowances Double Wide",
    icon: SiteImprovementAllowancesIcon,
    link: "https://docs.porchpass.com/branded/porchpass/msp-allowance-chart/site-improvement-allowances-double-wide.pdf",
  },
];

export const sellerConditionsData = [
  {
    title: "Contract Request Form",
    icon: ContractRequestFormIcon,
    link: "https://docs.porchpass.com/branded/porchpass/seller-conditions/contract-request-form.pdf",
  },
  {
    title: "Retailer Disclosure Cert",
    icon: RetailerDisclosureCertIcon,
    link: "https://docs.porchpass.com/branded/porchpass/seller-conditions/retailer-disclosure-cert.pdf",
  },
];
